// eslint-disable-next-line no-redeclare, @typescript-eslint/no-redeclare
import { Button, Center, Group, Text } from '@mantine/core';
import { IconCalendarTime, IconQuestionCircle } from '@tabler/icons';
import { closeAllModals, openModal } from '@mantine/modals';
import { RoutingS } from '../../../Service/RoutingS';
import BookitupAlert from '../../../Atoms/BookitupAlert';
import { BookitupTutorialButtonV2 } from '../../../Atoms/BookitupTutorialIcon';

export const openScheduleMeetingModal = () =>
  openModal({
    title: (
      <Text weight="bolder" size="xl">
        Der E-Mail-Versand ist fehlgeschlagen
      </Text>
    ),
    children: (
      <>
        <Text>
          Hast du Probleme beim Einrichten? Mach einfach einen Termin mit unserem Technik-Support und wir lösen das
          Problem gemeinsam.
        </Text>
        <Center>
          <Button
            leftIcon={<IconCalendarTime size={16} />}
            mt="md"
            onClick={() => {
              RoutingS.openInNewTab('https://hey.bookitup.de/meetings/sebastian-mahlke/technik-support');
              closeAllModals();
            }}
          >
            Termin vereinbaren
          </Button>
        </Center>
      </>
    ),
  });

const ScheduleMeetingAlert = () => (
  <BookitupAlert icon={<IconQuestionCircle />} title="Hilfe erforderlich?">
    <Text>
      Hast du Probleme beim Einrichten? Mach einfach einen Termin mit unserem Technik-Support und wir lösen das Problem
      gemeinsam.
    </Text>
    <Group mt="md">
      <Button
        size="xs"
        leftIcon={<IconCalendarTime size={16} />}
        onClick={() => RoutingS.openInNewTab('https://hey.bookitup.de/meetings/sebastian-mahlke/technik-support')}
      >
        Termin vereinbaren
      </Button>
      <BookitupTutorialButtonV2
        videoUrl="https://app.bookitup.de/academy/channels/automatic-responses?episodeId=9yar1sis4n"
        name="CreateContactForm"
        label="Video-Anleitung"
      />
    </Group>
  </BookitupAlert>
);

export default ScheduleMeetingAlert;
